import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";

function NoticeModal({ notice, onSave, onClose }) {
  const [form, setForm] = useState({
    title: notice?.title || "",
    content: notice?.content || "",
    priority: notice?.priority || "normal"
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.content.trim()) {
      toast.error("Title and content are required");
      return;
    }
    onSave(form);
  };

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-[#0a0a0a] border border-white/10 w-full max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-white/5">
          <h3 className="font-heading text-sm uppercase tracking-wide text-white">
            {notice ? 'Edit Notice' : 'Add Notice'}
          </h3>
          <button onClick={onClose} className="text-zinc-500 hover:text-white transition-colors bg-transparent border-none cursor-pointer">
            <X size={18} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-4 space-y-4">
          <div>
            <label className="block text-xs tracking-[0.2em] uppercase text-zinc-400 font-body mb-2">Title</label>
            <input
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              placeholder="e.g., S15 arriving Monday"
              className="w-full bg-transparent border-b border-white/10 text-white font-body text-sm py-2 px-0 outline-none focus:border-[#3b82f6]/50 placeholder:text-zinc-700 transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs tracking-[0.2em] uppercase text-zinc-400 font-body mb-2">Content</label>
            <textarea
              value={form.content}
              onChange={(e) => setForm({ ...form, content: e.target.value })}
              placeholder="Details, reminders, notes..."
              rows={4}
              className="w-full bg-transparent border border-white/10 text-white font-body text-sm p-2 outline-none focus:border-[#3b82f6]/50 placeholder:text-zinc-700 transition-colors resize-none"
            />
          </div>
          <div>
            <label className="block text-xs tracking-[0.2em] uppercase text-zinc-400 font-body mb-2">Priority</label>
            <div className="flex gap-2">
              {[
                { key: 'low', label: 'Low', color: 'zinc' },
                { key: 'normal', label: 'Normal', color: 'amber' },
                { key: 'high', label: 'High', color: 'red' },
              ].map((p) => (
                <button
                  key={p.key}
                  type="button"
                  onClick={() => setForm({ ...form, priority: p.key })}
                  className={`flex-1 py-2 text-xs uppercase font-body border cursor-pointer transition-colors ${
                    form.priority === p.key
                      ? p.key === 'high' ? 'bg-red-500/20 text-red-400 border-red-500/30'
                        : p.key === 'low' ? 'bg-zinc-500/20 text-zinc-400 border-zinc-500/30'
                        : 'bg-[#f59e0b]/20 text-[#f59e0b] border-[#f59e0b]/30'
                      : 'bg-transparent border-white/10 text-zinc-600 hover:text-zinc-400'
                  }`}
                >
                  {p.label}
                </button>
              ))}
            </div>
          </div>
          <div className="flex gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2 text-xs uppercase font-body border border-white/10 text-zinc-500 hover:text-white transition-colors cursor-pointer bg-transparent"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 py-2 text-xs uppercase font-body bg-[#f59e0b] text-white border-none hover:bg-[#f59e0b]/80 transition-colors cursor-pointer"
            >
              {notice ? 'Update' : 'Add'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export { NoticeModal };
